// Deterministic avatar treatment for entity initials, colored from a stable
// hash of the id. Token-backed classes only — no hex — per the app color rule.
// (rd-combobox.tsx and rd-avatar.tsx predate this module with local hex
// variants; converging them is a follow-up, not this ticket.)

const AVATAR_CLASSES = [
  "bg-ai",
  "bg-sky-500",
  "bg-success",
  "bg-sunlight-500",
  "bg-orange-500",
  "bg-primary",
] as const;

// Under the always theme every avatar is lime with olive initials (D3); the
// values are theme-only (client/src/styles.css).
export const AVATAR_BRAND =
  "brand:bg-(--color-avatar) brand:text-(color:--color-avatar-foreground)";

export function avatarClass(id: string): string {
  let hash = 0;
  for (let i = 0; i < id.length; i++) hash = (hash * 31 + id.charCodeAt(i)) | 0;

  return `${AVATAR_CLASSES[Math.abs(hash) % AVATAR_CLASSES.length]} ${AVATAR_BRAND}`;
}

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();

  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
